export default {"src":"/_next/static/media/arrow_down.6ce98116.svg","height":12,"width":19,"blurWidth":0,"blurHeight":0};